import type { ChildAccidentDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/accident';
import {
    getCoverageTermValue,
    formatAmountWithCurrency
} from '../coverableDetailsInsuranceSumsConfig';
import ViewHippoInformationModal from '../../../../shared_components/ViewHippoInformationModal/ViewHippoInformationModal';
import type { TableInformation } from '../../../../config/flavourConfig';

const getChildAccidentInsuranceSumsCoverableDetailsConfig = (
    childCoverable: ChildAccidentDTO
): TableInformation => {
    return {
        title: 'Forsikringssummer',
        rowsInformation: [
            {
                name: 'Varigt mén ved ulykke - erstatningen er en procentdel af forsikringssummen',
                fieldValue: formatAmountWithCurrency(
                    getCoverageTermValue(
                        childCoverable,
                        'ACCChildPermInjuryAccidentCov',
                        'ACCChildPermInjAccCovSumInsured'
                    )
                ),
                valueType: 'amount',
                hidden: !getCoverageTermValue(
                    childCoverable,
                    'ACCChildPermInjuryAccidentCov',
                    'ACCChildPermInjAccCovSumInsured'
                )
            },
            {
                key: 'ACCChildPermInjAccCovPermInjDegree',
                name: 'Erstatningen starter ved méngrad på',
                fieldValue: `${getCoverageTermValue(
                    childCoverable,
                    'ACCChildPermInjuryAccidentCov',
                    'ACCChildPermInjAccCovPermInjDegree'
                )}%`,
                hidden: !getCoverageTermValue(
                    childCoverable,
                    'ACCChildPermInjuryAccidentCov',
                    'ACCChildPermInjAccCovPermInjDegree'
                )
            },
            {
                name: 'Dobbelterstatning starter ved',
                fieldValue: `${getCoverageTermValue(
                    childCoverable,
                    'ACCChildPermInjuryAccidentCov',
                    'ACCChildPermInjAccCovDoubleComp'
                )}%`,
                hidden: !getCoverageTermValue(
                    childCoverable,
                    'ACCChildPermInjuryAccidentCov',
                    'ACCChildPermInjAccCovDoubleComp'
                )
            },
            {
                name: 'Akut psykologisk krisehjælp til barnet',
                fieldValue: `${Number.parseInt(
                    getCoverageTermValue(
                        childCoverable,
                        'ACCChildPermInjuryAccidentCov',
                        'ACCChildPermInjAccCovPhsycAssistance'
                    )
                )} timer`,
                hidden: !getCoverageTermValue(
                    childCoverable,
                    'ACCChildPermInjuryAccidentCov',
                    'ACCChildPermInjAccCovPhsycAssistance'
                )
            },
            {
                name: 'Rådigshedsbeløb - ekstrabeløb til forældre/værger ved varigt mén fra 30%',
                fieldValue: formatAmountWithCurrency(
                    getCoverageTermValue(
                        childCoverable,
                        'ACCChildPermInjuryAccidentCov',
                        'ACCChildPermInjAccCovDisposalAmount'
                    )
                ),
                valueType: 'amount',
                hidden: !getCoverageTermValue(
                    childCoverable,
                    'ACCChildPermInjuryAccidentCov',
                    'ACCChildPermInjAccCovDisposalAmount'
                )
            },
            {
                name: 'Varigt mén ved kritisk sygdom - erstatningen er en procentdel af forsikringssummen',
                fieldValue: formatAmountWithCurrency(
                    getCoverageTermValue(
                        childCoverable,
                        'ACCChildPermInjuryCriticalIllnessesCov',
                        'ACCChildPermInjIllnessCovSumInsured'
                    )
                ),
                valueType: 'amount',
                hidden: !getCoverageTermValue(
                    childCoverable,
                    'ACCChildPermInjuryCriticalIllnessesCov',
                    'ACCChildPermInjIllnessCovSumInsured'
                )
            },
            {
                key: 'ACCChildPermInjIlnessCovPermInjDegree',
                name: 'Erstatningen starter ved méngrad på',
                fieldValue: `${getCoverageTermValue(
                    childCoverable,
                    'ACCChildPermInjuryCriticalIllnessesCov',
                    'ACCChildPermInjIlnessCovPermInjDegree'
                )}%`,
                hidden: !getCoverageTermValue(
                    childCoverable,
                    'ACCChildPermInjuryCriticalIllnessesCov',
                    'ACCChildPermInjIlnessCovPermInjDegree'
                )
            },
            {
                name: 'Tand- og tyggeskader',
                fieldValue: 'Efter regning',
                valueType: 'modalLink',
                modalInformation: {
                    modalType: ViewHippoInformationModal,
                    modalProps: {
                        title: 'DSS-ACC-HIGHLIGHTED-TEXT-MODAL-EFTER-REGNING-TITLE',
                        description: 'DSS-ACC-CHILD-HIGHLIGHTED-TEXT-MODAL-EFTER-REGNING'
                    }
                }
            },
            {
                name: 'Udgifter til behandling',
                fieldValue: formatAmountWithCurrency(
                    getCoverageTermValue(
                        childCoverable,
                        'ACCChildRehabilitationCov',
                        'ACCChildRehabCovTreatment'
                    ).split('.')[0]
                ),
                valueType: 'amount',
                hidden: !getCoverageTermValue(
                    childCoverable,
                    'ACCChildRehabilitationCov',
                    'ACCChildRehabCovTreatment'
                )
            },
            {
                name: 'Skade på briller',
                fieldValue: formatAmountWithCurrency(
                    getCoverageTermValue(
                        childCoverable,
                        'ACCChildGlassesCov',
                        'ACCChildGlassesCovRepair'
                    )
                ),
                valueType: 'amount',
                hidden: !getCoverageTermValue(
                    childCoverable,
                    'ACCChildGlassesCov',
                    'ACCChildGlassesCovRepair'
                )
            },
            {
                name: 'Første par briller efter synsnedsættelse efter ulykke eller kritisk sygdom',
                fieldValue: formatAmountWithCurrency(
                    getCoverageTermValue(
                        childCoverable,
                        'ACCChildGlassesCov',
                        'ACCChildGlassesCovFirstGlassesAcc'
                    )
                ),
                valueType: 'amount',
                hidden: !getCoverageTermValue(
                    childCoverable,
                    'ACCChildGlassesCov',
                    'ACCChildGlassesCovFirstGlassesAcc'
                )
            },
            {
                name: 'Begravelseshjælp',
                fieldValue: formatAmountWithCurrency(
                    getCoverageTermValue(
                        childCoverable,
                        'ACCChildFuneralAssistanceCov',
                        'ACCChildFuneralCovPaymentOnDeath'
                    )
                ),
                valueType: 'amount',
                hidden: !getCoverageTermValue(
                    childCoverable,
                    'ACCChildFuneralAssistanceCov',
                    'ACCChildFuneralCovPaymentOnDeath'
                )
            },
            {
                name: 'Udbetaling ved enkelt brud eller overrivning',
                fieldValue: formatAmountWithCurrency(
                    getCoverageTermValue(
                        childCoverable,
                        'ACCChildImmediateCompAccidentCov',
                        'ACCChildImmCompAccCovOneBreak'
                    )
                ),
                valueType: 'amount',
                hidden: !getCoverageTermValue(
                    childCoverable,
                    'ACCChildImmediateCompAccidentCov',
                    'ACCChildImmCompAccCovOneBreak'
                )
            },
            {
                name: 'Udbetaling ved flere samtidige brud eller overrivninger',
                fieldValue: formatAmountWithCurrency(
                    getCoverageTermValue(
                        childCoverable,
                        'ACCChildImmediateCompAccidentCov',
                        'ACCChildImmCompAccCovSeveralBreaks'
                    )
                ),
                valueType: 'amount',
                hidden: !getCoverageTermValue(
                    childCoverable,
                    'ACCChildImmediateCompAccidentCov',
                    'ACCChildImmCompAccCovSeveralBreaks'
                )
            },
            {
                name: 'Kompensation ved hospitalsindlæggelse efter ulykke - beløb pr. dag (fra 3.-dagen)',
                fieldValue: formatAmountWithCurrency(
                    getCoverageTermValue(
                        childCoverable,
                        'ACCChildImmediateCompAccidentCov',
                        'ACCChildImmCompAccCovHospitalDay'
                    )
                ),
                valueType: 'amount',
                hidden: !getCoverageTermValue(
                    childCoverable,
                    'ACCChildImmediateCompAccidentCov',
                    'ACCChildImmCompAccCovHospitalDay'
                )
            },
            {
                key: 'ACCChildImmCompAccCovHospitalYear',
                name: 'Beløbsgrænse pr. år',
                fieldValue: formatAmountWithCurrency(
                    getCoverageTermValue(
                        childCoverable,
                        'ACCChildImmediateCompAccidentCov',
                        'ACCChildImmCompAccCovHospitalYear'
                    )
                ),
                valueType: 'amount',
                hidden: !getCoverageTermValue(
                    childCoverable,
                    'ACCChildImmediateCompAccidentCov',
                    'ACCChildImmCompAccCovHospitalYear'
                )
            },
            {
                name: 'Strakserstatning ved visse kritiske sygdomme',
                fieldValue: formatAmountWithCurrency(
                    getCoverageTermValue(
                        childCoverable,
                        'ACCChildImmedCompCriticalIllnessCov',
                        'ACCChildImmCompIllCovImmCompIll'
                    )
                ),
                valueType: 'amount',
                hidden: !getCoverageTermValue(
                    childCoverable,
                    'ACCChildImmedCompCriticalIllnessCov',
                    'ACCChildImmCompIllCovImmCompIll'
                )
            },
            {
                name: 'Kompensation ved hospitalsindlæggelse efter kritisk sygdom - beløb pr. dag (fra 3.-dagen)',
                fieldValue: formatAmountWithCurrency(
                    getCoverageTermValue(
                        childCoverable,
                        'ACCChildImmedCompCriticalIllnessCov',
                        'ACCChildImmCompIllCovHospitalDay'
                    )
                ),
                valueType: 'amount',
                hidden: !getCoverageTermValue(
                    childCoverable,
                    'ACCChildImmedCompCriticalIllnessCov',
                    'ACCChildImmCompIllCovHospitalDay'
                )
            },
            {
                key: 'ACCChildImmCompIllCovHospitalyear',
                name: 'Beløbsgrænse pr. år',
                fieldValue: formatAmountWithCurrency(
                    getCoverageTermValue(
                        childCoverable,
                        'ACCChildImmedCompCriticalIllnessCov',
                        'ACCChildImmCompIllCovHospitalyear'
                    )
                ),
                valueType: 'amount',
                hidden: !getCoverageTermValue(
                    childCoverable,
                    'ACCChildImmedCompCriticalIllnessCov',
                    'ACCChildImmCompIllCovHospitalyear'
                )
            }
        ]
    };
};

export { getChildAccidentInsuranceSumsCoverableDetailsConfig };
